import { extendObservable } from 'mobx';
// import config from 'config';
import camelcaseKeys from 'camelcase-keys';
import snakecaseKeys from 'snakecase-keys';
import http from '../utils/http';

const initialData = {
  name: '',
};

export class CategoryStore {
  constructor() {
    extendObservable(this, {
      loading: false,
      categories: [],
      category: initialData,
    });
  }

  resetHoliday() {
    this.category = initialData;
  }

  setHoliday(category) {
    this.category = camelcaseKeys(category);
  }

  changeField(task, data) {
    this.category[task] = data;
  }

  async loadCategories() {
    this.loading = true;
    try {
      const categories = await http.get('/categories');
      this.categories = camelcaseKeys(categories);
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async loadCategory(id) {
    this.loading = true;
    try {
      const categories = await http.get(`/categories/${id}`);
      if (categories) {
        this.setHoliday(categories);
      }
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async createCategory() {
    this.loading = true;
    const data = snakecaseKeys(this.category);
    try {
      const response = await http.post('/categories', data);
      return response
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async updateCategory(id) {
    this.loading = true;
    const data = snakecaseKeys(this.category);
    try {
      const response = await http.put(`/categories/${id}`, data);
      return response
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }

  async deleteCategory(id) {
    this.loading = true;
    try {
      const category = await http.delete(`/categories/${id}`);
      if (category) {
        this.categories = this.categories.filter(val => val.id !== id);
      }
      return category;
    } catch (error) {
      throw error;
    } finally {
      this.loading = false;
    }
  }
}

const categoryStore = new CategoryStore();
export default categoryStore;
